// flaskConfig.js
import axios from "axios";
import { logoutUser, refreshAccessToken } from "../api/config"; // import from .NET interceptor file
import { ApiKey } from "../api/endpoints";

//  BASE URLS

//export const FLASK_API_URL = "http://127.0.0.1:5000/qdrantapi";
export const FLASK_API_URL = process.env.REACT_APP_PYTHON_FLASK_API_URL ;

//  FLASK AXIOS INSTANCE

export const flaskAuthAxios = axios.create({
  baseURL: FLASK_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

//   FLASK PUBLIC ENDPOINTS

const FLASK_PUBLIC_ENDPOINTS = ["/search", "/uploadAudioAndGetVoiceResponse"];

const isPublicEndpoint = (url = "") =>
  FLASK_PUBLIC_ENDPOINTS.some((e) => url === e || url.startsWith(e + "/"));

//   FLASK REQUEST INTERCEPTOR

flaskAuthAxios.interceptors.request.use(
  (config) => {
    if (isPublicEndpoint(config.url)) return config;

    const token = localStorage.getItem("token");
    if (!token) {
      logoutUser(); // use imported function
      throw new axios.Cancel("Session expired");
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

//   FLASK RESPONSE INTERCEPTOR

flaskAuthAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error?.response?.status;
    const tokenExpired = error?.response?.data?.token_expired;

    // skip public endpoints
    if (isPublicEndpoint(originalRequest?.url)) {
      return Promise.reject(error);
    }

    // refresh ONLY if backend says token_expired === true
    if (status === 401 && tokenExpired === true && !originalRequest._retry) {
      originalRequest._retry = true;

      const newToken = await refreshAccessToken(); // use imported function
      if (newToken) {
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return flaskAuthAxios(originalRequest);
      }

      logoutUser(); // use imported function
      return Promise.reject(error);
    }

    // invalid token / forbidden / malformed header
    if (status === 401 || status === 403) {
      logoutUser(); // use imported function
    }

    return Promise.reject(error);
  }
);
